// src/modules/app-views/invoices/pages/Init/actions/actionButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { PlusOutlined } from '@ant-design/icons';

// *******************************************************************************
// ACTION BUTTON
// *******************************************************************************
const invoicesInitActionButton = () => {
  return {
    action: 'new',
    hideButton: false,
    label: 'new',
    tooltip: 'new_invoice',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,

    onClick: ({ navigate, setPage }) => {
      setPage({
        navigate,
        pageName: 'document',
        params: { _id: 'add' },
      });
    },

    dropdownItems: [],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default invoicesInitActionButton;
